import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Grid, Chip, Typography, CircularProgress } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import './settings.css'
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import { toast } from 'react-toastify';
import { DataGrid } from '@mui/x-data-grid';
import UserSettingsHeader from '../../components/HeadersNav/userSettingsHeader';

const PersonalPayrollReport = () => {
	const { user } = useContext(AuthContext)
	const [loading, setLoading] = useState(false);
	const [payrollData, setPayrollData] = useState([]);
	const [payrollList, setPayrollList] = useState([]);
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);

	const columns = [
		{
			field: 'Shift_Date', headerName: 'Shift Date', flex: 1, minWidth: 150,
			valueGetter: (params) => { return moment(params?.row?.shift_date).format('MM/DD/YY') }
		},

		{
			field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 130,
			renderCell: (params) => {
				return (
					<Chip style={{ width: '60px' }}
						label={params?.row?.shift_name}
						className={params?.row?.shift_name == "Day" ? 'day-chip' : 'night-chip'} />)
			}
		},

		{
			field: 'Hours', headerName: 'Hours', flex: 1, minWidth: 160,
			renderCell: (params) => {
				return `${params?.row?.hours_worked} (${varFormatTime(timeFormat(params?.row?.start_time), user?.Time_Format)} - ${varFormatTime(timeFormat(params?.row?.end_time), user?.Time_Format)})`
			}
		},

		{
			field: 'Pay', headerName: 'Pay', flex: 1, minWidth: 160, valueGetter: (params) => "$ " + params?.row?.shift_pay
		},
	]

	const getPayrollList = (loader = true) => {
		if (loader) {
			setLoading(true);
		}
		ApiService.get("/payroll/generate-report")
			.then(({ data }) => {
				setPayrollData(data?.data)
				setPayrollList(data?.data?.shift_details);
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	};

	let year, month;
	if (payrollData?.payroll_month) {
		[year, month] = payrollData.payroll_month.split('-');
	}

	const acceptPayroll = () => {
		let body = {
			"month": parseInt(month, 10),
			"year": year
		}
		ApiService.post("/payroll/approval-report", body)
			.then((data) => {
				toast.success(data?.message)
				getPayrollList(false)
				setLoading(false);
			})
			.catch(({data}) => {
				toast.error(data?.message)
				setLoading(false);
			});
	};

	useEffect(() => {
		getPayrollList()
	}, [])
	return (
		<>
			<UserSettingsHeader />
			{loading ? (
				<>
					<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam p-4" style={{ marginTop: "1rem" }}>
						<CircularProgress />
					</Paper>
				</>
			) :
				(
					<>
						<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
							<Grid container spacing={2} className='align-items-center'>

								{/* Heading */}
								<Grid item xs={10} md={12} style={{ display: 'flex', justifyContent: 'space-between' }}>
									<Typography variant="h5">Personal Payroll Report for {payrollData?.formatted_payroll_month}</Typography>
									<div style={{ display: 'flex', gap: "15px" }}>
										<h5 style={{ marginBottom: '0px', marginTop: '6px' }}>Total Shifts- {payrollData?.total_shifts}</h5>
										<ButtonTheme onClick={acceptPayroll} color='primary'>Acknowledge Payroll</ButtonTheme>
									</div>
								</Grid>
							</Grid>

							{!payrollList || payrollList.length == 0 ?
								<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 400 }}>
									<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
									<span className='mt-4' style={{ color: '#555555' }}>
										No Payroll Found
									</span>
								</div>
								:
								<>
									<div className='mt-4'>
										<DataGrid
											rows={payrollList}
											columns={columns}
											checkboxSelection={false}
											hideFooter={true}
											sx={{
												"& .MuiDataGrid-columnHeaderTitleContainer": {
													display: "flex !important",
												},
												"& .MuiTablePagination-selectLabel": {
													marginBottom: "0 !important"
												},
												"& .MuiTablePagination-displayedRows": {
													marginBottom: "0 !important"
												},
												"& .MuiDataGrid-columnHeader": {
													minWidth: "100px",
												},
											}}
										/>
									</div>
								</>
							}
							<div>
								<h5 className='final-text'>Total Hours- {payrollData?.total_hours}</h5>
								<h5>Grand Total- $ {payrollData?.total_pay}</h5>
							</div>
						</Paper>
					</>
				)
			}
		</>
	)
}
export default PersonalPayrollReport